var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('mem-button',{on:{"click":_vm.findRace}},[_vm._v(_vm._s(_vm.$t(_vm.text)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }